import React, { ReactNode } from 'react';

import cls from 'classnames';

import AircraftIcon from '@ott/icon-aircraft';
import BusIcon from '@ott/icon-bus';
import CarsIcon from '@ott/icon-cars';
import CloseIcon from '@ott/icon-close';
import HotelsIcon from '@ott/icon-hotels';
import RailwaysIcon from '@ott/icon-railways';
import Modal from '@ott/modal';

import { LoaderArc } from './blocks/LoaderArc';
import { LoaderArrows } from './blocks/LoaderArrows';

import styles from './LoadingOverlay.scss';

const locators = {
  childIcon: 'loading-overlay-child-icon',
  icon: 'loading-overlay-icon',
  text: 'loading-overlay-text',
};

const contentOptions = {
  header: false,
  hideClose: true,
  transparent: true,
};

const icons = {
  // @ts-ignore
  avia: <AircraftIcon className={styles.childIcon} />,
  // @ts-ignore
  cars: <CarsIcon className={styles.childIcon} />,
  // @ts-ignore
  hotels: <HotelsIcon className={styles.childIcon} />,
  // @ts-ignore
  railways: <RailwaysIcon className={styles.childIcon} />,
  // @ts-ignore
  buses: <BusIcon className={styles.childIcon} />,
};

type Icon = keyof typeof icons;

type Props = {
  text?: ReactNode;
  icon?: Icon;
  adNode?: ReactNode;
  className?: string;
  onClose?: () => void;
};

type LoaderWithIconProps = {
  icon: Icon;
};

const LoaderWithIcon = ({ icon }: LoaderWithIconProps) => (
  <>
    <div className={styles.loaderIcon} data-locator={locators.icon}>
      <LoaderArrows className={styles.loaderArrows} />
    </div>
    <div className={styles.childIconWrapper} data-locator={locators.childIcon}>
      {icons[icon]}
    </div>
  </>
);

const DefaultLoader = () => (
  <div className={styles.loaderIcon} data-locator={locators.icon}>
    <LoaderArc />
  </div>
);

const LoadingOverlay = ({ icon, text, adNode, className, onClose }: Props): JSX.Element => {
  return (
    <Modal isOpen={true} contentOptions={contentOptions}>
      <div className={cls(styles.container, className)}>
        {onClose && (
          <button className={styles.closeButton} type="button" onClick={onClose}>
            <CloseIcon className={styles.closeIcon} />
          </button>
        )}
        <div className={styles.loader}>
          {icon ? <LoaderWithIcon icon={icon} /> : <DefaultLoader />}
        </div>
        {text && (
          <div className={styles.text} data-locator={locators.text}>
            {text}
          </div>
        )}
      </div>
      {adNode}
    </Modal>
  );
};

export default LoadingOverlay;
